<template functional>
  <div
    :class="[
      $options.$styles.item,
      data.class,
      data.staticClass,
      {
        'opacity-100': props.loaded,
      },
    ]"
    :data-test="props.dataTest || null"
  >
    <div
      :class="{
        ' flex-0 ': props.collapsePrimary,
        ' flex-1 ': !props.collapsePrimary,
      }"
    >
      <div v-if="$slots.before" :class="$options.$styles.beforeSlot">
        <slot name="before"></slot>
      </div>

      <div :class="$options.$styles.defaultSlot">
        <slot></slot>
      </div>

      <div v-if="$slots.tertiary" :class="$options.$styles.tertiarySlot">
        <slot name="tertiary"></slot>
      </div>
    </div>

    <slot name="secondary"></slot>

    <div v-if="$slots.after" :class="$options.$styles.afterSlot">
      <slot name="after"></slot>
    </div>
  </div>
</template>

<script>
export default {
  $styles: {
    item: `
      c-item group relative md:flex opacity-0 transition-opacity-color-fill-bgcolor border-bg-lightest border-t py-2
    `,
    defaultSlot: `
      c-item__primary flex max-md:mb-px relative items-center
    `,
    tertiarySlot: `
      c-item__tertiary inline-block max-md:text-xl md:mr-1 pb-1 my-px pl-1 md:pl-2
    `,
    beforeSlot: `
      c-item__before absolute max-md:mr-px max-md:pr-px mr-2 md:py-1 r-full text-center max-md:text-xl
    `,
    afterSlot: `
      c-item__after absolute l-full t
    `,
  },
}
</script>
